module.exports = __webpack_public_path__ + "static/media/p_PCG_Logo_Intro.05fa29bb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_PCG_Logo_Intro.mp4
// module id = 556
// module chunks = 0